/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Slider from "react-slick";
import ProductImg from "../../../assets/product-img.png";
import Button from "../button";
import StarRatings from "react-star-ratings";
import QuantityButton from "../quantity-button";
import {
  addCartEntries,
  deductCartEntriesCount,
} from "../../../services/commerceServices/cartServices";
import fallbackImage1 from "../../../assets/fallbackImage1.png";

// Interface for ProductCard Props
interface ProductCardProps {
  productSliderSettings?: any;
  handleLearnMore: () => void;
  handleSuccessMsg?: any;
  productData?: any;
  subType?: string;
  handleAddCartClick: (productCode: number, quantity: number) => void;
  addCartClicked?: boolean;
  hitState?: boolean;
  needStateImages?: any;
  t?: any;
  handleOutOfStock?: () => void;
}

// Interface for ProductCard State
interface ProductCardState {
  addCartClicked: boolean;
  quantity: number;
}

/**
 * ProductCard component.
 *
 * @namespace ProductCard
 */

var x: any;
class ProductCard extends React.Component<ProductCardProps, ProductCardState> {
  constructor(props: ProductCardProps) {
    super(props);
    this.state = {
      addCartClicked: false,
      quantity: 1,
    };
  }

  handleAddCart = (productCode: number) => {
    this.setState(
      {
        addCartClicked: true,
      },
      () => {
        this.props.handleAddCartClick(productCode, this.state.quantity);
        this.setState({
          quantity: 1,
        });
      }
    );
  };

  handleLearnMore = () => {
    this.setState(
      {
        quantity: 1,
      },
      () => {
        this.props.handleLearnMore();
      }
    );
  };
  handleLearnMoreKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.handleLearnMore();
    }
  };
  increaseQuantity = (productCode: number) => {
    this.setState(
      {
        quantity: this.state.quantity + 1,
      },
      () => {
        clearInterval(x);
        x = setInterval(() => {
          addCartEntries(productCode, this.state.quantity - 1).then(() => {
            clearInterval(x);
            this.props.handleSuccessMsg();
            this.setState({
              quantity: 1,
            });
          });
        }, 1000);
      }
    );
  };
  decreaseQuantity = (productCode: number, entryNumber: number) => {
    if (this.state.quantity && this.state.quantity > 1) {
      this.setState(
        {
          quantity: this.state.quantity - 1,
        },
        () => {
          deductCartEntriesCount(productCode, this.state.quantity, entryNumber);
        }
      );
    }
  };

  hitStateincreaseQuantity = () => {
    this.setState({
      quantity: this.state.quantity + 1,
    });
  };
  hitStatedecreaseQuantity = () => {
    if (this.state.quantity && this.state.quantity > 1) {
      this.setState({
        quantity: this.state.quantity - 1,
      });
    }
  };

  render() {
    const { productSliderSettings, productData, hitState } = this.props;
    const { addCartClicked, quantity } = this.state;
    const fallBackImageCard: any =
      localStorage.getItem("results-info") !== "undefined" &&
      localStorage.getObj("results-info")?.fallbackimagecard?.url;
    const fallBackImageProduct: any =
      localStorage.getItem("results-info") !== "undefined" &&
      localStorage.getObj("results-info")?.fallbackimageproduct?.url;

    return (
      <div className="white-cards">
        <div className="inner-wrapper col-md-12 clearfix">
          <div className="top-wrapper">
            <div className="slider-wrapper clearfix">
              <div className="silder-images-wrapper">
                {productData?.data?.images?.length > 0 ? (
                  <Slider {...productSliderSettings}>
                    {productData?.data?.images
                      ?.filter((element: any) => element.format === "product")
                      ?.map((item: any) => (
                        <>
                          <div className="slider-main-img">
                            <img
                              tabIndex={-1}
                              role="img"
                              aria-labelledby="product-name"
                              className={"slider-img"}
                              src={
                                `${process.env.REACT_APP_IMGAE_BASE_URL}` +
                                item?.publicUrl
                                  ? `${process.env.REACT_APP_IMGAE_BASE_URL}` +
                                    item?.publicUrl
                                  : hitState
                                  ? fallBackImageCard
                                  : fallBackImageCard
                              }
                              alt=""
                            />
                          </div>
                        </>
                      ))}
                  </Slider>
                ) : (
                  <div className="fallback-main-img">
                    <div className="fallback-img">
                      <img
                        src={hitState ? fallBackImageCard : fallBackImageCard}
                        alt=""
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-wrapper">
            <div className="product-detail-wrapper clearfix">
              <div className="product-detail">
                {/* <div className="need-state-icons">
                  {this.props.needStateImages &&
                    this.props.needStateImages.length > 0 &&
                    this.props.needStateImages.map((item: any) => (
                      <div
                        className="icon icon-list"
                        style={{
                          backgroundImage: item ? `url(${item})` : ``,
                        }}
                      />
                    ))}
                  {/* <div className="icon icon-list"></div>
                  <div className="icon icon-list"></div>
                  <div className="icon icon-list"></div> */}
                {/* </div> */}
                <div className="product-name" id="product-name">
                  {productData?.data?.name}
                  {/* n* by Nutrilite™ Less Stress, More Yes – Relax Gummies */}
                </div>
                {/* <div className="product-recommended">
                30 servings - Recommended use: 2 per day
              </div> */}
                {this.props.subType === "best" && (
                  <div className="rating-star-wrapper">
                    <StarRatings
                      rating={
                        productData?.reviews?.Results[0]?.ProductStatistics
                          ?.ReviewStatistics?.AverageOverallRating || 0
                      }
                      numberOfStars={
                        productData[0]?.reviews?.Results[0]?.ProductStatistics
                          ?.ReviewStatistics?.OverallRatingRange || 5
                      }
                      //rating={3}
                      starRatedColor="#F1C400"
                      //numberOfStars={5}
                      name="rating"
                      starDimension="15px"
                      starSpacing="2px"
                      // svgIconPath={
                      //   "M13.8942 5.07885C13.8939 5.07881 13.8936 5.07877 13.8934 5.07873L10.2791 4.55457C10.2789 4.55454 10.2786 4.55451 10.2784 4.55448L10.278 4.55442L10.3498 4.0596C10.2798 4.0496 10.2248 4.0096 10.1948 3.94961L13.8942 5.07885ZM13.8942 5.07885C14.168 5.12128 14.3826 5.30398 14.4629 5.55608L14.4628 5.55609L14.465 5.5626C14.548 5.8117 14.481 6.08659 14.2863 6.27542L14.2853 6.2764L11.6705 8.82633C11.491 8.99394 11.4278 9.22827 11.4604 9.44021L11.4603 9.44022L11.4618 9.44881L12.0817 13.0584L12.0821 13.0604C12.1287 13.3255 12.0224 13.586 11.8048 13.7448L11.8048 13.7448L11.8026 13.7464C11.6836 13.8343 11.539 13.8787 11.3946 13.8787C11.2821 13.8787 11.17 13.8518 11.0732 13.7992L11.0732 13.7992L11.067 13.7959L7.83413 12.0997C7.63479 11.989 7.38112 11.9772 7.16522 12.1026L3.93328 13.7958L3.93087 13.7971C3.6967 13.9214 3.41633 13.9033 3.19385 13.7438C2.97713 13.5849 2.87139 13.3249 2.91791 13.0604L2.91825 13.0584L3.53819 9.44881L3.53827 9.44883L3.5396 9.4402C3.57219 9.22829 3.50899 8.99393 3.32946 8.8263L0.714731 6.2764L0.713719 6.27542C0.518995 6.08659 0.45198 5.81171 0.535019 5.56259L0.535064 5.5626L0.53714 5.55608C0.617248 5.30431 0.831391 5.12176 1.10474 5.07902L4.72099 4.55457C4.72121 4.55454 4.72143 4.55451 4.72165 4.55448L13.8942 5.07885Z"
                      // }
                      svgIconPath={
                        "M13.9695 4.58455L10.3498 4.0596C10.2798 4.0496 10.2248 4.0096 10.1948 3.94961L8.57495 0.664934C8.37497 0.25497 7.96 0 7.50004 0C7.04008 0 6.62511 0.254986 6.42512 0.664934L4.80526 3.94961C4.77527 4.0096 4.72027 4.0496 4.65028 4.0596L1.03059 4.58455C0.575624 4.65454 0.200665 4.96451 0.0606768 5.40447C-0.0843106 5.83944 0.0356789 6.31439 0.365642 6.63437L2.98541 9.18918C3.03541 9.23418 3.05541 9.29918 3.04541 9.36418L2.42546 12.9738C2.34547 13.4288 2.53045 13.8787 2.90043 14.1487C3.27541 14.4187 3.76035 14.4537 4.16531 14.2387L7.40999 12.5388C7.46498 12.5038 7.53498 12.5038 7.59497 12.5388L10.8347 14.2387C11.0097 14.3337 11.2047 14.3787 11.3946 14.3787C11.6396 14.3787 11.8896 14.3037 12.0996 14.1487C12.4695 13.8787 12.6545 13.4288 12.5745 12.9738L11.9546 9.36418C11.9446 9.29918 11.9646 9.23419 12.0146 9.18918L14.6344 6.63437C14.9643 6.31439 15.0843 5.83943 14.9393 5.40447C14.7993 4.96451 14.4244 4.65454 13.9694 4.58455H13.9695Z"
                      }
                      svgIconViewBox={"0 0 15 15"}
                    />
                    <span className="label">
                      <span>
                        {productData?.reviews?.Results[0]?.ProductStatistics
                          ?.ReviewStatistics?.AverageOverallRating
                          ? productData?.reviews?.Results[0]?.ProductStatistics?.ReviewStatistics?.AverageOverallRating?.toFixed(
                              1
                            ) + " ("
                          : "0   ("}
                      </span>

                      <span>
                        {productData?.reviews?.Results[0]?.ProductStatistics
                          ?.ReviewStatistics?.TotalReviewCount
                          ? productData?.reviews?.Results[0]?.ProductStatistics
                              ?.ReviewStatistics?.TotalReviewCount + ") "
                          : 0 + ") "}
                      </span>
                      {this.props.t("common.reviews")}
                    </span>
                    {/* <span className="label">
                      {productData?.reviews?.Results[0]?.ProductStatistics
                        ?.ReviewStatistics?.AverageOverallRating +
                        "  (" +
                        productData?.reviews?.Results[0]?.ProductStatistics
                          ?.ReviewStatistics?.TotalReviewCount +
                        ") Reviews"}
                    </span> */}
                  </div>
                )}
              </div>
              <div className="product-price">
                {productData?.data?.price?.formattedValue}
              </div>
            </div>
            <div className="product-description-wrapper">
              {this.props.subType === "best" && (
                <div className="descriptions" dangerouslySetInnerHTML={{__html: productData?.data?.shortDescription || ""}}>
                  {/* {productData?.data?.summary} */}
                  {/* HELPS YOU FIND YOUR ZEN – L-Theanine, a natural amino acid that
                helps reduce occasional stress, and lemon balm, a calming
                botanical, help get you in your zone. */}
                </div>
              )}
              <div
                tabIndex={0}
                role="link"
                className="learn-more"
                onClick={this.handleLearnMore}
                onKeyPress={(e) => this.handleLearnMoreKeyPress(e)}
              >
                {this.props?.t("common.learn_more_product")}
              </div>
            </div>
          </div>
        </div>
        {hitState ? (
          <div className="add-to-cart-wrapper">
            <QuantityButton
              name={quantity}
              className="app-btn btn-quantity"
              handleDecrease={() => this.hitStatedecreaseQuantity()}
              handleIncrease={() => this.hitStateincreaseQuantity()}
            />
            {productData?.data?.stock?.stockLevel > 0 ? (
              <Button
                name={this.props.t("common.add_to_cart")}
                className="app-btn btn-icon"
                onButtonClick={() =>
                  this.handleAddCart(productData?.data?.code)
                }
              />
            ) : (
              <Button
                name={this.props.t("common.add_to_cart")}
                className="app-btn out-of-stock"
                onButtonClick={() => {
                  this.props.handleOutOfStock && this.props.handleOutOfStock();
                }}
                // onButtonClick={
                //   () => this.handleOutOfStock()
                //   // this.handleAddtoCart(
                //   //   this.state.selectedProducts[0]?.data
                //   //     ?.code
                //   // )
                // }
              />
            )}
          </div>
        ) : (
          <div className="add-to-cart-wrapper">
            {addCartClicked ? (
              <QuantityButton
                name={quantity}
                className="app-btn btn-quantity"
                handleDecrease={() =>
                  this.decreaseQuantity(productData?.data?.code, 2)
                }
                handleIncrease={() =>
                  this.increaseQuantity(productData?.data?.code)
                }
              />
            ) : // <Button
            //   name={this.props.t("common.add_to_cart")}
            //   className="app-btn btn-icon"
            //   onButtonClick={() =>
            //     this.handleAddCart(productData?.data?.code)
            //   }
            // />
            productData?.data?.stock?.stockLevel > 0 ? (
              <Button
                name={this.props.t("common.add_to_cart")}
                className="app-btn btn-icon"
                onButtonClick={() =>
                  this.handleAddCart(productData?.data?.code)
                }
              />
            ) : (
              <Button
                name={this.props.t("common.add_to_cart")}
                className="app-btn out-of-stock"
                onButtonClick={() => {
                  this.props.handleOutOfStock && this.props.handleOutOfStock();
                }}
                // onButtonClick={
                //   () => this.handleOutOfStock()
                //   // this.handleAddtoCart(
                //   //   this.state.selectedProducts[0]?.data
                //   //     ?.code
                //   // )
                // }
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ProductCard;
